<template>
  <div class="mapPower">
    <div id="container" class="xiexinChangePowerMap" style="top:0"></div>

    <div class="mapPower-btn">
      <van-button type="info" round style="margin-right: 20px" @click="handleToAddress(1)">前往装货点</van-button>
      <van-button type="info" round @click="handleToAddress(2)">前往卸货点</van-button>
    </div>
  </div>
</template>
<script type="text/javascript">
// import AMapLoader from '@amap/amap-jsapi-loader';
import {Toast} from 'vant';

export default {
  name: 'xiexinmapwebview',
  data() {
    return {
      map: null,
      AMap: null,
      AMapUI: null,
      token: null,
      baseurl: null,
      stationAllList: [], // 所有的站点列表
      changeStationList: [], // 换电站列表
      pileStationList: [], // 充电站列表
      stationCovers: [],  // 站点集合
      layer: null,   // 点标记
      actionAdress: {},   // 地址
      location: [116.379028, 39.865042],  // 定位
      driving: null,  // 规划的路线
      objectMarkerList: null,   // markerList对象
      licensePlate: null,  // 车牌号码
      longitude: null, //经度
      latitude: null, //纬度
      locations: '',
      startLocation: [],
      endLocation: [],
      startAddress: null,
      endAddress: null
    }
  },
  computed: {
    getAmapAppLink() {
      const lat = 31.25607
      const lon = 120.663297
      const name = '苏州红苹果'
      // 使用自定义 URL 协议打开高德地图 App
      var userAgent = navigator.userAgent;

      // 通过正则表达式检测用户代理字符串
      if (/android/i.test(userAgent)) {
        // 用户是在Android设备上访问
        return `amapuri://route/plan/?sourceApplication=dnx&dlat=${lat}&dlon=${lon}&dname=${name}&dev=0&t=0`
      } else if (/iphone|ipad|ipod/i.test(userAgent)) {
        return `iosamap://path?sourceApplication=dnx&dlat=${lat}&dlon=${lon}&dname=${name}&dev=0&t=0`
      }
    },
  },
  created() {
    let _this = this;
    document.title = "地图"
    if (this.$route.query.startLocation) {
      this.startLocation = this.$route.query.startLocation.split(",")
      this.startAddress = this.$route.query.startAddress
    }
    if (this.$route.query.endLocation) {
      this.endLocation = this.$route.query.endLocation.split(",")
      this.endAddress = this.$route.query.endAddress
    }
    this.token = this.$route.query.token ? this.$route.query.token : "bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiIxODEwMDUiLCJzY29wZSI6WyJhbGwiXSwic2luZ2xlTG9naW4iOiIyIiwiZXhwIjoxNjYxNDUxNzkwLCJhdXRob3JpdGllcyI6WyJhYSJdLCJqdGkiOiJlZTdkZjA3ZS0wNDc2LTQ2YWQtODA5OS02MWQyNmY1YWUzMTEiLCJjbGllbnRfaWQiOiJhZG1pbiIsInRva2VuIjoiZ2NsbG9naW5fdG9rZW5fOWUxNmExYjAyYzgxNGI3NTg2MWM3NTAyY2JmZDNiYzEifQ.O7gcJ2YvMvIhkEDPEOB1eWBw-ucK3hU380yFiWtfll-tJCJNtO8L_S4oKQL3cyRBsOPpUtdpot5GTZtVs3JOeSsKA_gV3ll9npKaUiOc2PGojzEmYXwJNrJzDRjNMb721sgESoYobZWc6ilCZG5r0EVhbRhiwg3-l6wQLe1_QP60Grf4SQ1a-Jlg7iMp7jdS_sivC0i80E_PibTfpoIv_hPdEfXoQe7DJcE0BRNpdcke0pN7dG85iI86lXY6m5E02tyvclivnj549Rg7vuRL351cnRILLnrZWxImXNGErsya1ZNWSeaMVbz77FwneSYvvk2VDIcdOU7mBVu9dyqvIg";
    this.baseurl = this.$route.query.baseurl ? this.$route.query.baseurl : 'https://sass.gclme.com';
    window._AMapSecurityConfig = {
      securityJsCode: '5d52d08f659664f824f5021ef237b1c0'
    }
    var elem = document.createElement("script");
    elem.src = "https://webapi.amap.com/maps?v=2.0&key=3c323c18d7f2d237ba10b4f06c5a1648&plugin=AMap.Driving,AMap.Geolocation";
    document.body.appendChild(elem);
    elem.onload = elem.onreadystatechange = function () {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        var elemUI = document.createElement("script");
        elemUI.src = "https://webapi.amap.com/ui/1.1/main.js";
        document.body.appendChild(elemUI);
        elemUI.onload = elemUI.onreadystatechange = function () {
          if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {

            _this.initMap();
          }
        }
      }
    }
  },
  watch: {},
  methods: {
    // 打开地图导航
    handleOpenMap (lat, lon, name){
      wx.miniProgram.getEnv(function(res){
        console.log(res)
        if (res.miniprogram){
          console.log(res.miniprogram)

          wx.miniProgram.navigateTo({url: "/pages/mapwebview/locationMapwebview?latitude="+ lat +"&longitude="+ lon +"&address="+ name});
        }
      });
    },
    handleToAddress(value) {
      // 装货
      if (value === 1) {
        this.handleOpenMap(this.startLocation[1], this.startLocation[0], this.startAddress)
        return;
      }

      // 卸货
      if (this.endLocation.length && this.endAddress)
        this.handleOpenMap(this.endLocation[1], this.endLocation[0], this.endAddress);
    },
    initMap() {
      let _this = this;
      Toast.loading({
        message: '加载地图中...',
        forbidClick: true,
        duration: 0
      });
      this.AMap = AMap;
      this.AMapUI = AMapUI;
      this.map = new AMap.Map('container', {
        viewMode: "3D",    //是否为3D地图模式
        center: [116.469881, 39.993599],//初始化地图中心点位置
      });
      this.AMapUI.loadUI(['misc/MarkerList'], function (MarkerList) {
        //启动页面
        _this.objectMarkerList = MarkerList
        _this.createMap();

      })
    },
    createMap() {
      if (this.startLocation.length && this.endLocation.length) {
        const list = [
          {id: 1, position: this.startLocation, location: this.startLocation,},
          {id: 2, position: this.endLocation, location: this.endLocation,}
        ]
        if (list.length) {
          let _this = this;
          //创建一个实例
          var markerList = new this.objectMarkerList({
            map: this.map, //关联的map对象
            //列表的dom容器的id
            getDataId: function (dataItem, index) {
              //返回数据项的Id
              return dataItem.id;
            },
            getPosition: function (dataItem) {
              //返回数据项的经纬度，AMap.LngLat实例或者经纬度数组
              return dataItem.position;
            },
            getMarker: function (dataItem, context, recycledMarker) {
              var content;
              if (dataItem.id === 1) {
                content = '<div class="map-box" >' +
                  '<div class="bottom-box">' +
                  '<img class="bottom-icon" src="https://sass.gclme.com/api/file/Image/annex/20220719_1e4070d31cd94e1baf66410461a7c573.png">' +
                  '<div class="bottom-info">装'
                '</div>' +
                '</div>' +
                '</div>'
              } else {
                content = '<div class="map-box" >' +
                  '<div class="bottom-box">' +
                  '<img class="bottom-icon" src="https://sass.gclme.com/api/file/Image/annex/20220711_e9f95a0d37eb4c8986d305162e1dee91.png">' +
                  '<div class="bottom-info">卸'
                '</div>' +
                '</div>' +
                '</div>'
              }
              var label = {
                offset: new AMap.Pixel(16, 18),
                content: content
              };

              if (recycledMarker) {
                //存在可回收利用的marker,直接setLabel返回
                recycledMarker.setLabel(label);
                return recycledMarker;
              }
              //返回一个新的Marker
              return new AMap.Marker({
                // label: label,
                content: content
              });
            },

            getInfoWindow: function (dataItem, context, recycledInfoWindow) {
              console.log('jin 绘制路线', dataItem);
              _this.mapLine().then((res) => {
                console.log('绘制路线返回数据', res);
                Object.assign(dataItem, res)
                var timeStr = 0;
                if (dataItem.drivingTime / 60 > 60) {
                  timeStr = parseInt(dataItem.drivingTime / 3600) + '小时' + parseInt(('0.' + dataItem.drivingTime % 3600) * 60) + '分钟'
                } else {
                  timeStr = (dataItem.drivingTime / 60).toFixed(2) + '分钟'
                }
                var topBoxDome = document.getElementsByClassName("top-box");
                topBoxDome[0].innerHTML = timeStr + "," + (dataItem.drivingDistance / 1000).toFixed(2) + 'km'
              })
              // <%- dataItem.drivingTime %>分钟,<%- dataItem.desc %>km<div class="down-icon"></div>
              var tpl = '<div class="top-box"></div>';
              //MarkerList.utils.template支持underscore语法的模板
              var content = markerList.utils.template(tpl, {
                dataItem: dataItem,
                dataIndex: context.index
              });
              if (recycledInfoWindow) {
                //存在可回收利用的infoWindow, 直接setContent返回
                recycledInfoWindow.setContent(content);
                return recycledInfoWindow;
              }
              //返回一个新的InfoWindow
              return new AMap.InfoWindow({
                offset: new AMap.Pixel(0, -23),
                content: content
              });
            },

          });
          //监听选中改变
          markerList.on('selectedChanged', function (event, info) {

          });

          //监听Marker和ListElement上的点击，详见markerEvents，listElementEvents
          markerList.on('markerClick listElementClick', function (event, record) {
            // console.log(event, record)
          });

          //绘制数据源，Let's go!
          markerList.render(list);

          markerList.selectByDataId(list[0].id)

          this.markerList = markerList;
          Toast.clear();
          //清除数据
          //markerList.render([]);
        } else {
          Toast.fail('没有装货点/卸货点!');
        }
      }
    },
    mapLine() {
      console.log('近绘制路线');
      var _this = this;
      return new Promise(function (res, rej) {
        if (_this.driving && _this.driving.render) {
          _this.driving.render.clear();
        }
        _this.driving = new _this.AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_TIME,//速度最快的策略
          map: _this.map,
          hideMarkers: true,
          autoFitView: true //自动调整地图视野使绘制的路线处于视口的可见范围
        })
        _this.actionAdress = {
          planDeliveryPosition: _this.startLocation,
          planCollectPosition: _this.endLocation,
        };

        let tempList = _this.$route.query.taskPathPlans ? JSON.parse(_this.$route.query.taskPathPlans) : []

        if(tempList.length>16) {
          tempList = tempList.slice(0,16)
        }

        _this.driving.search(_this.startLocation, _this.endLocation,{
          waypoints: tempList
        }, function (status, result) {
          if (status === 'complete') {
            res({
              drivingDistance: result.routes[0].distance,
              drivingTime: result.routes[0].time,
            })
          } else {
            rej(result)
            console.log('Driving', result)
          }
        })
      })
    },
  }
}
</script>
<style scoped>
.mapPower {
  position: relative;
}

.mapPower .mapPower-btn {
  position: fixed;
  left: 0;
  bottom: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.xiexinChangePowerMap .map-box {
  font-size: 0.32rem;
  color: #0A2463;
  display: flex;
  flex-direction: column;
  position: relative;
  left: -0.74rem;
  /* top: -0.4rem; */
  top: -1.4rem;
}

.xiexinChangePowerMap .top-box {
  white-space: nowrap;
  font-size: 0.32rem;
  color: #0A2463;
  /* position: absolute;
  top:-1.066667rem;
  left:-0.533333rem; */
  height: 0.933333rem;
  border-radius: 0.466667rem;
  padding: 0px 0.4rem;
  display: flex;
  align-items: center;
  background: #fff;
  box-shadow: 0px 0px 16px 0px rgba(10, 36, 99, 0.0800);
}

.xiexinChangePowerMap .down-icon {
  width: 0px;
  height: 0px;
  border-left: 0.133333rem solid transparent;
  border-right: 0.133333rem solid transparent;
  border-top: 0.133333rem solid #fff;
  position: absolute;
  left: 50%;
  bottom: -0.133333rem;
  transform: translateX(-50%);
  box-shadow: 0px 0px 16px 0px rgba(10, 36, 99, 0.0800);
}

.xiexinChangePowerMap .bottom-box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.xiexinChangePowerMap .bottom-icon {
  width: 1.52rem;
  height: 1.626667rem;
}

.xiexinChangePowerMap .bottom-info {
  position: absolute;
  background: #fff;
  left: 1rem;
  z-index: -1;
  height: 0.933333rem;
  display: flex;
  align-items: center;
  padding-left: 0.533333rem;
  padding-right: 0.3rem;
  border-radius: 0px 0.466667rem 0.466667rem 0px;
  white-space: nowrap;
}

.xiexinChangePowerMap .amap-info-content {
  padding: 0px;
  overflow: hidden;
  background: none;
  box-shadow: none;
}

.xiexinChangePowerMap .amap-info-close {
  display: none;
}

.xiexinChangePowerMap .amap-info-contentContainer {
  position: relative;
  top: -0.6rem;
}

.xiexinChangePowerMap .amap-marker-label {
  border: none;
  background: none;
}

.xiexinChangePowerMap .car-icon {
  height: 1.6rem;
}

.xiexinChangePowerMap .selected .bottom-info {
  background: linear-gradient(90deg, #58A3FF 0%, #1980FF 100%);
  color: #fff;
}

.xiexinChangePowerMap .rotate45 {
  transform: rotate(45deg);
}

.xiexinChangePowerMap .rotate90 {
  transform: rotate(90deg);
}

.xiexinChangePowerMap .rotate135 {
  transform: rotate(135deg);
}

.xiexinChangePowerMap .rotate180 {
  transform: rotate(180deg);
}

.xiexinChangePowerMap .rotate225 {
  transform: rotate(225deg);
}

.xiexinChangePowerMap .rotate270 {
  transform: rotate(270deg);
}
</style>
<style lang="stylus" scoped>
@import "./mapwebview.scss";
</style>



// WEBPACK FOOTER //
// mapwebviewPowertransport.vue?528c3372